import EnFlag from '../images/flags/en-flag.png';
import EsFlag from '../images/flags/es-flag.png';

export const flags = {
  en: EnFlag,
  es: EsFlag,
  'en-bold': EnFlag,
  'es-bold': EsFlag,
};
